import { useEffect } from 'react'
import './nameDialog.css'
import { GUID } from '../Services/ServiceTypes'
import { FolderNode, getNodeById } from '../WooNotes/folders'
import { WooNotesButton, WooNotesButtonColor, WooNotesButtonSize } from '../WooNotes/WooNotesButton'

type Props = {
  moveNode: { nodeId: GUID; newParentId: GUID | undefined } | undefined
  folderNodes: FolderNode[]
  onOK: () => void
  onCancel: () => void
}

export const ConfirmMoveNodeDialog = ({ moveNode, folderNodes, onOK, onCancel }: Props) => {
  useEffect(() => {
    if (!moveNode) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel()
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [moveNode, onCancel])

  if (!moveNode) return null

  const nodeName = getNodeById(folderNodes, moveNode.nodeId)?.name
  const newParentName = moveNode.newParentId ? getNodeById(folderNodes, moveNode.newParentId)?.name : 'Root'
  if (!nodeName) return null

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        <h3>
          Are you sure you want to move {nodeName} to {newParentName}?
        </h3>

        <div className="actions">
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.White} onClick={() => onCancel()}>
            Cancel
          </WooNotesButton>
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.Blue} onClick={() => onOK()}>
            OK
          </WooNotesButton>
        </div>
      </div>
    </div>
  )
}
